import styled from 'styled-components';
import { BadgeOverlay, Spinner } from 'react-rainbow-components';
import ButtonIcon from 'components/ButtonIcon';
import CustomersInfo from 'components/CustomersInfo';

import {
    PURPLE_500, PURPLE_100, WHITE, GREY_800, DIVIDER, HIGHLIGHT,
} from '../../constants';

export const NotificationMenuContainer = styled.div`
    position: relative;
    display: block;
`;

export const StyledButtonIcon = styled(ButtonIcon)`
    flex-shrink: 0;
`;

export const StyledSpinner = styled(Spinner)`
    position: relative;
    z-index: 1;
    top: unset;
    left: unset;
    transform: unset;
`;

export const StyledBadgeOverlay = styled(BadgeOverlay)`
    & > span {
        font-size: 10px;
        font-weight: 500;
        line-height: 11px;
        text-align: center;
        min-width: 18px;
        height: 18px;
    }
`;

export const DropdownContainer = styled.div`
    background-color: ${WHITE};
    color: ${GREY_800};
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.06), 0px 8px 24px 0px rgba(75, 70, 92, 0.16);
    width: 400px;
    border-radius: 0.75rem;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 2rem);
    overflow: hidden;
`;

export const Header = styled.header`
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 0.75rem 1rem;
    border-bottom: solid 1px ${DIVIDER};
    font-size: 0.875rem;
    font-weight: 600;
    height: 3rem;
    box-sizing: border-box;
`;

export const CallsList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 320px;
    overflow-y: auto;
`;

export const CallItem = styled.li`
    display: flex;
    padding: 0.75rem;
    align-items: center;
    gap: 0.75rem;
    background: ${WHITE};
    cursor: pointer;

    &:hover {
        background: ${HIGHLIGHT};
    }

    &:not(:last-child) {
        border-bottom: 1px solid ${DIVIDER};
    }
`;

export const CallUserInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

export const CallMetadata = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    min-width: 100px;
`;

export const CallTypeContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.6;
    min-width: 20px;
`;

export const CallTypeIcon = styled.div`
    display: flex;
    align-items: center;
    
    & svg {
        width: 32px;
        height: 32px;
        color: ${GREY_800};
    }
`;

export const CallTypeLabel = styled.span`
    font-size: 0.6875rem;
    font-weight: 500;
    color: ${GREY_800};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const CallTimerContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.375rem;
`;

export const CallTimerIcon = styled.div`
    display: flex;
    align-items: center;
    opacity: 0.7;
    
    & svg {
        width: 14px;
        height: 14px;
        color: ${GREY_800};
    }
`;

export const CallTimerDisplay = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.8125rem;
    font-weight: 600;
    color: ${PURPLE_500};
    background-color: ${PURPLE_100};
    padding: 0.25rem 0.5rem;
    border-radius: 0.5rem;
    border: 1px solid rgba(115, 103, 240, 0.15);
    min-width: 52px;
    justify-content: center;
    font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
    letter-spacing: 0.025em;
    line-height: 1.2;
    box-shadow: 0 1px 2px rgba(115, 103, 240, 0.1);
    
    & svg {
        width: 12px;
        height: 12px;
        color: ${PURPLE_500};
        opacity: 0.8;
    }
`;

export const CallActions = styled.div`
    display: flex;
    align-items: center;
`;

export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 1.5rem;
    text-align: center;
    background: linear-gradient(145deg, rgba(115, 103, 240, 0.02) 0%, rgba(115, 103, 240, 0.05) 100%);
    border-radius: 0.5rem;
    margin: 0.75rem;
`;

export const EmptyIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: linear-gradient(145deg, ${PURPLE_100} 0%, rgba(115, 103, 240, 0.08) 100%);
    margin-bottom: 1rem;
    
    & svg {
        width: 32px;
        height: 32px;
        color: ${PURPLE_500};
        opacity: 0.7;
    }
`;

export const EmptyTitle = styled.h3`
    font-size: 1rem;
    color: ${GREY_800};
    font-weight: 600;
    margin: 0 0 0.5rem 0;
    line-height: 1.2;
`;

export const EmptyMessage = styled.p`
    font-size: 0.875rem;
    color: ${GREY_800};
    opacity: 0.7;
    margin: 0;
    line-height: 1.4;
    max-width: 200px;
`;

export const StyledCustomersInfo = styled(CustomersInfo)`
    & > div {
        width: 100%;

        & span[data-id="title"]: {
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
`;
